import DataTable from "@shared/ui/data-table/DataTable";
import SearchTable from "@shared/ui/search-table/SearchTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledWorks } from "./works.styled";
import { SEARCH_TABLE_STYLE } from "./works.constants";
import { useWorkOptions } from "./works.data";
import { useWorkStructures } from "./useWorkStructures";
import { useWorksBrowse } from "./useWorksBrowse";
import { useWorksNavigation } from "./useWorksNavigation";

function Works() {
  const theme = useTheme();
  const { searchStructure, tableStructure } = useWorkStructures();
  const browse = useWorksBrowse();
  const navigation = useWorksNavigation();
  const workOptions = useWorkOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledWorks>
      {searchStructure ? (
        <SearchTable
          structure={searchStructure}
          useForm={browse.workSearchForm}
          setStructure={navigation.editSearchStructure}
          reset={browse.reset}
          style={SEARCH_TABLE_STYLE}
        />
      ) : (
        <Skeleton variant="rectangular" height={100} animation="wave" sx={skeletonSx} />
      )}
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={workOptions}
          selectRow={navigation.selectRow}
          onSelectRow={navigation.rowChosen}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledWorks>
  );
}

export default Works;
